import { BrandliveEvent } from '@/types/projects.types';
import { EPaletteModes, ThemePack } from '@/types/theme-packs.types';

const getAdjustedEmailPack = (
  project: BrandliveEvent,
  themeMode: EPaletteModes,
  themePack: ThemePack
): BrandliveEvent => {
  // If project does not have a "detached" email pack, then also update the email pack with the new color pack,
  // an email pack is considered "detached" if the user has made an email theme pack selection at any time for the project.
  // If project.settings.email.detachedEmailFromEventThemePack is false, then we need to update the email pack
  // however, we need to make sure not to apply this to existing projects, so we need to make sure the field exists
  if ('detachedEmailFromEventThemePack' in (project?.settings?.email || {})) {
    if (!project?.settings?.email?.detachedEmailFromEventThemePack) {
      return {
        ...project,
        settings: {
          ...project?.settings,
          email: {
            ...project?.settings?.email,
            color_palette_mode: themeMode,
            colors: themePack,
          },
        },
      };
    }
  }

  return project;
};

export default getAdjustedEmailPack;
